import useCMSPageData from "../hooks/useCMSPageData";

const { createContext } = require("react");

/**
 * @typedef {{
 *   body: string | undefined;
 *   includeRelated: boolean;
 *   canonicalHREF: string;
 *   sitepageid: number;
 *   contentGroupItems?: import("../types").ContentGroupItem[];
 *   hero: import("../types").CMSPageHero;
 *   meta: import("../types").CMSPageMeta;
 *   loading: boolean;
 *   displayListTitle: string;
 *   displayListTop: "Y" | "N";
 *   bulletedFormat: "Y" | "N";
 *   error: number;
 *   relateResultsFieldOptions: Record<string, unknown>;
 * }} IContentPageContext
 */

/** @type {React.Context<IContentPageContext>} */
const ContentPageContext = createContext({
  body: '',
  includeRelated: false,
  canonicalHREF: '',
});
export default ContentPageContext;

/**
 * @param {{
 *   sitepageid: string | number;
 *   pagedata?: import("../components/types").CMSPage;
 *   alias?: string;
 *   isLoading?: boolean;
 *   mutateBody?: (data: string) => string;
 *   renderOtherType?: boolean;
 *   bypassLogin?: boolean;
 *   bypassAuth?: boolean;
 *   children: import("react").ReactNode;
 *   sitepageid: number | string;
 * }} props
 */
export const ContentPageContextProvider = ({ children, ...props }) => {
  const cmsPage = useCMSPageData(props);
  
  const { 
    body, 
    canonicalHREF, 
    contentGroupItems, 
    data,
    error, 
    hero, 
    meta, 
    loading, 
    unauthorizedError
  } = cmsPage;

  let displayListTitle = data?.DisplayListTitle ?? '';
  let displayListTop = data?.DisplayListTop ?? '';
  let bulletedFormat = data?.BulletedFormat ?? '';
  let includeRelated = data?.IncludeRelated === 'Y';
  let relateResultsFieldOptions = {
    Subjects: data?.ContentGroups ? [] : data?.CurrentSubjects,
    ContentItems: data?.ContentGroups
      ? data?.ContentGroupItems.filter(element => {
          return element.ContentItemId.toString() === props.sitepageid?.toString();
        })
      : [],
    Publications: [...(data?.ContentGroups || (!data?.Publications?.length ? [] : data?.Publications))],
  };

  return (
    <ContentPageContext.Provider value={{
      body, 
      canonicalHREF, 
      hero, 
      meta,
      bulletedFormat,
      displayListTitle,
      displayListTop,
      includeRelated,
      loading,
      sitepageid: props.sitepageid,
      contentGroupItems,
      relateResultsFieldOptions,
      error: error ? 404 : unauthorizedError ? 401.4 : null,
    }}>
      {children}
    </ContentPageContext.Provider>
  )
}